import { useEffect, useRef, useState } from 'react';
import { ProTableOt, Toaster, toast, Row, Col, Button, useProTableOt } from '../../ui/ot'
import { useBorrower } from '../controllers/BorrowerController';
import dayjs from 'dayjs'
import { Link } from 'react-router-dom';
import { useHold } from '../controllers/HoldController';
const HoldsProTableOt = ({
    borrowernumber: borrowernumber
}) => {
    const actionRef = useRef()
    const columns = [
        {
            title: '預約日',
            dataIndex: 'reserve',
            key: 'reserve',
            render: (text, record) => {
                const reserve_reservedate = record?.reserve_reservedate
                return <>{dayjs(reserve_reservedate).format('YYYY-MM-DD')}</>
            }
        },
        {
            title: '書名',
            dataIndex: 'bib_title',
            key: 'bib_title',
            render: (text, record) => {
                return <>
                    <Link to={'/library/backstage/AddItem/' + record?.bib_biblionumber} style={{ color: 'blue' }}>{text}{record?.bib_subtitle}</Link>{record?.bib_author}
                </>
            }
        },
        {
            title: '索書號',
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: '種類',
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: 'Barcode',
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: '取書分館',
            dataIndex: 'issue_branchname',
            key: 'issue_branchname',
            render: (_, record) => {
                return <>
                    {record?.reserve?.find(_=>true)?.reserve_branchname}
                </>
            }
        },
        {
            title: '過期',
            dataIndex: 'issue_charge',
            key: 'issue_charge',
        },
        {
            title: '操作',
            dataIndex: 'returnBook',
            key: 'returnBook',
            render: (_, record) => {
                return <>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Button variant="destructive" onClick={() => onCancel({ reserve_data: [{ reserve_id: record?.reserve?.find(_ => true)?.reserve_id }] })}>取消預約</Button>
                        </Col>
                    </Row>
                </>
            }
        },
    ];

    const setParamsFilter = (obj) => {
        return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
    }

    const onBefore = (value) => {
        console.log('onBefore', value)
    }
    const onFinish = (value) => {
        const axiosMode = value?.axiosMode
        const axiosStatus = value?.status
        switch (axiosMode) {
            case 'post':
                if (axiosStatus === 'success') toast.success('續借成功 !')
                else if (value?.message === "Renewal not authorized (too_many)") toast.error('續借失敗 ! 已達續借上限。')
                else if (value?.message === "Renewal not authorized (on_reserve)") toast.error('續借失敗 ! 預約中。')
                else toast.error('續借失敗 ! issue_id 並不存在')
                break;
            case 'delete':
                if (axiosStatus === 'success') toast.success('取消成功 !')
                else if (value?.message === "Renewal not authorized (too_many)") toast.error('續借失敗 ! 已達續借上限。')
                else if (value?.message === "Renewal not authorized (on_reserve)") toast.error('續借失敗 ! 預約中。')
                else toast.error('續借失敗 ! issue_id 並不存在')
                actionRef.current.reloadAndRest()
                break;
            default:
                break;
        }
    }
    // const Renew = () => {
    //     let RenewArray = selectedRowsInfo.map((row) => {
    //         return {
    //             "issue_id": row?.issue_id,  //row.issue_id
    //         }
    //     })
    //     postCheckoutRenewData(RenewArray)
    // }
    const onCancel = ({
        reserve_data = []
    }) => {
        deleteHoldData(reserve_data)
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log({
                selected, selectedRows, changeRows
            })
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.key)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.key);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {


            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.key)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.key)
                selectRow = selectRow.filter(row => row.key !== record.key)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
        transferColumnAntdToShadcn,
        transferSortAntdToShadcn
    } = useProTableOt({
        columns
    })
    const {
        HoldData,
        getHoldData,
        postHoldData,
        deleteHoldData
    } = useHold({
        onBefore,
        onFinish
    })
    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {
        },
        onFinish: () => {
        }
    })

    useEffect(() => {
        if (borrowernumber)
            getBorrowerData({
                borrowernumber: borrowernumber
            })
    }, [borrowernumber])

    const borrower = BorrowerData?.find(_ => true)
    return <>
        <Toaster richColors position="top-center" />
        <ProTableOt
            actionRef={actionRef}
            columns={columns}
            rowKey={'reserve'}
            request={async (params = {}, sort, filter) => {
                // setAxiosMode("get")
                let newParams = {
                };
                let order = setOrders(sort)
                newParams = {
                    // ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                    ...newParams,
                    order,
                    size: params.pageSize,
                    cur_page: params.current,
                    custom_filter_value: params.keyword ?? "",
                    custom_filter_key: custom_filter_key,
                    borrowernumber: borrowernumber,
                    // "categorycode": "TEST",
                };
                newParams = setParamsFilter({
                    ...newParams,
                });
                // setPageSize(params?.pageSize ?? 20)
                return getHoldData({
                    ...newParams
                })
            }}
            rowSelection={{
                selectedRowKeys: [],
                type: "checkbox",
                onSelectAll: rowSelection?.onSelectAll,
                onSelect: rowSelection?.onSelect,
                onChange: rowSelection?.getCheckboxProps
            }}
        />
        <Row gutter={[8, 8]}>
            <Col>
                <Button onClick={() => onCancel({ reserve_data: selectedRowsInfo.map(item => ({ reserve_id: item?.reserve?.reserve_id })) })} variant='outline' disabled={selectedRowsInfo.length === 0}>取消勾選項目</Button>
            </Col>
            <Col hidden>
                <Button onClick={() => { }} variant='outline' disabled={selectedRowsInfo.length === 0}>續借勾選項目</Button>
            </Col>
            <Col hidden>
                <Button onClick={() => { }} variant='outline' >續借所有項目</Button>
            </Col>
        </Row>
    </>
}
export default HoldsProTableOt